<script setup>
import ContainerRoot from '@js/components/containers/ContainerRoot.vue';
import VariablesContent from '@js/components/contents/VariablesContent.vue';
import DialogModal from '@js/components/dialogs/DialogModal.vue';

const { title, variables } = defineProps({
    title: {
        type: [Object, String],
        required: true,
    },
    variables: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <DialogModal size="large">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title>
            {{ title }}
        </template>

        <template #content>
            <ContainerRoot>
                <VariablesContent :variables="variables" />
            </ContainerRoot>
        </template>
    </DialogModal>
</template>
